import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Hur överklagar jag ett beslut om serveringstillstånd?";
const SHORT_ANSWER = "Beslut överklagas till förvaltningsrätten inom tre veckor från det att du fick del av beslutet.";

export const Route = createFileRoute("/fraga/hur-overklagar-jag-ett-beslut")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Hur överklagar jag ett beslut om serveringstill…" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Kommunen kan ompröva sitt beslut innan ärendet skickas vidare. Det finns inga avgifter att överklaga, men du bör motivera överklagandet sakligt och bifoga underlag."}
      source={{ label: "Alkohollagen (2010:1622) – Riksdagen", href: "https://www.riksdagen.se/sv/dokument-och-lagar/dokument/svensk-forfattningssamling/alkohollag-20101622_sfs-2010-1622/" }}
      extraSources={[]}
      deepGuide={{ to: "/serveringstillstand", label: "Serveringstillstånd – överklagande" }}
      related={[{"to": "/fraga/nar-leder-sanktionsavgift", "label": "Vad är en sanktionsavgift och när tas den ut?"}, {"to": "/fraga/vad-galler-vid-misstankt-narkotikahandel", "label": "Vad gäller om jag misstänker narkotikahandel i lokalen?"}, {"to": "/fraga/vad-hander-om-jag-far-en-anmarkning", "label": "Vad händer om jag får en anmärkning vid tillsyn?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Hur överklagar jag ett beslut om serveringstillstånd?" },
      { name: "description", content: "Beslut överklagas till förvaltningsrätten inom tre veckor från det att du fick del av beslutet." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/hur-overklagar-jag-ett-beslut" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/hur-overklagar-jag-ett-beslut" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/hur-overklagar-jag-ett-beslut",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Hur överklagar jag ett beslut om serveringstill…", url: "https://alkoholprovet.se/fraga/hur-overklagar-jag-ett-beslut" },
      ]),
    ],
  }),
});
